module.exports = new __parcel__URL__("c1s4.2d54b9c5.png").toString();